import { render, staticRenderFns } from "./MultiLanguageInput.vue?vue&type=template&id=9edbe862&scoped=true"
import script from "./MultiLanguageInput.vue?vue&type=script&setup=true&lang=js"
export * from "./MultiLanguageInput.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9edbe862",
  null
  
)

export default component.exports